    <template>
        <div class="pad20">
            <div class="vx-row m-0 main-list-panel">
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo' ,'name') || checkProperty(petition,'sponsorInfo' ,'firstName') || 
                checkProperty(petition,'sponsorInfo' ,'middleName') || checkProperty(petition,'sponsorInfo' ,'lastName') ">
                    <div class="main-list">
                        <p>
                            Full Name
                            <!-- <span>{{formatFullname(petition.sponsorInfo)}}</span> -->
                            <span>{{checkProperty(petition,'sponsorInfo','name')}}</span>
                        </p>
                    </div>  
                </div>
                <template v-if="checkProperty(petition,'sponsorInfo' ,'email')">
                    <div class="vx-col md:w-1/3 w-full p-0" v-if="checkIsTempAccount(checkProperty(petition,'sponsorInfo' ,'email'))">
                        <div class="main-list">
                            <p>
                                Email
                                <span>{{checkProperty(petition,'sponsorInfo' ,'email')}}</span>
                            </p>
                        </div>
                    </div>
                </template>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo','gender')">
                    <div class="main-list">
                        <p>
                            Gender
                            <span style="text-transform: capitalize;">{{petition.sponsorInfo.gender}}</span>
                        </p>
                    </div>
                </div>
                <div  class="vx-col md:w-1/3 w-full p-0"
                v-if="checkProperty(petition,'sponsorInfo','cellPhoneNumber')"
                                >
                                    <div class="main-list">
                                    <p>
                                        Phone Number
                                        <span>
                                        <template v-if="checkProperty(petition['sponsorInfo'] ,'cellPhoneCountryCode' ,'countryCallingCode')">{{checkProperty(petition['sponsorInfo'] ,'cellPhoneCountryCode' ,'countryCallingCode')+"&nbsp;"}}{{petition.sponsorInfo.cellPhoneNumber | formatPhone}}</template>
                                        <template v-else>--</template>
                                        </span>
                                    </p>
                                    </div>
                                </div>
                
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo','alienNumber')">
                    <div class="main-list">
                        <p>
                            Alien Number
                            <span>{{checkProperty(petition,'sponsorInfo','alienNumber')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo','SSN')">
                    <div class="main-list">
                        <p>
                            Social Security Number
                            <span>{{petition.sponsorInfo.SSN}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo','dateOfBirth')">
                    <div class="main-list">
                        <p>
                            Date of Birth
                            <span>{{petition.sponsorInfo.dateOfBirth | formatDate}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'countryOfBirthDetails' ,'name')">
                    <div class="main-list">
                        <p>
                            Country of Birth
                            <span>{{checkProperty(petition['sponsorInfo'],'countryOfBirthDetails' ,'name')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'provinceOfBirthDetails' ,'name')">
                    <div class="main-list">
                        <p>
                            Province of Birth
                            <span>{{checkProperty(petition['sponsorInfo'],'provinceOfBirthDetails' ,'name')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'locationOfBirth' )">
                    <div class="main-list">
                        <p>
                            Location of Birth
                            <span>{{checkProperty(petition['sponsorInfo'],'locationOfBirth')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo' ,'maritalStatusDetails') || checkProperty(petition,'sponsorInfo' ,'maritalStatus') ">
                    <div class="main-list">
                        <p>
                            Marital Status
                            <span>{{ checkProperty(petition['sponsorInfo'] , "maritalStatusDetails" ,'name')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo','dateOfMarriage')">
                <div class="main-list">
                    <p>
                        Date of Marriage
                        <span>{{petition.sponsorInfo.dateOfMarriage | formatDate}}</span>
                    </p>
                </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'countryOfMarriageDetails' ,'name')">
                    <div class="main-list">
                        <p>
                            Country of Marriage
                            <span>{{checkProperty(petition['sponsorInfo'],'countryOfMarriageDetails' ,'name')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'provinceOfMarriageDetails' ,'name')">
                    <div class="main-list">
                        <p>
                            Province of Marriage
                            <span>{{checkProperty(petition['sponsorInfo'],'provinceOfMarriageDetails' ,'name')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'locationOfMarriage')">
                    <div class="main-list">
                        <p>
                            Location of Marriage
                            <span>{{checkProperty(petition['sponsorInfo'],'locationOfMarriage')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo','noOfChildrens')">
                <div class="main-list">
                    <p>
                        No of Childrens
                        <span>{{petition.sponsorInfo.noOfChildrens }}</span>
                    </p>
                </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo' ,'height') && (checkProperty(petition['sponsorInfo'] ,'height','feet') || checkProperty(petition['sponsorInfo'] ,'height','inches')) ">
                    <div class="main-list">
                        <p>
                            Height
                            <span>{{ convertHeight(checkProperty(petition['sponsorInfo'] ,'height')) }}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo' ,'weight') ">
                    <div class="main-list">
                        <p>
                            Weight
                            <span>{{ checkProperty(petition['sponsorInfo'] ,'weight')  }}<small>LBS</small></span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="false && checkProperty(petition,'sponsorInfo' ,'race') && checkProperty(petition['sponsorInfo'] ,'race','id')">
                    <div class="main-list">
                        <p>
                            Race
                            <span>{{ checkProperty(petition['sponsorInfo'] ,'race','name')  }}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'race') && checkProperty(petition['sponsorInfo'],'race' ,'length')>0 
                && formatCountriesName(checkProperty(petition['sponsorInfo'],'race' )) !=''" >
                    <div class="main-list">
                    <p>
                        Ethnicity/Race
                        <span>{{formatCountriesName(checkProperty(petition['sponsorInfo'],'race' )) }}</span>
                    </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo' ,'eyeColor') && checkProperty(petition['sponsorInfo'] ,'eyeColor','id')">
                    <div class="main-list">
                        <p>
                            Eye Color
                            <span>{{ checkProperty(petition['sponsorInfo'] ,'eyeColor','name')  }}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition,'sponsorInfo' ,'hairColor') && checkProperty(petition['sponsorInfo'] ,'hairColor','id')">
                    <div class="main-list">
                        <p>
                            Hair color
                            <span>{{ checkProperty(petition['sponsorInfo'] ,'hairColor','name')  }}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="canRenderField('doYouHaveMarriageCert',questionnaireDetails, false, 'sponsorInfo' )" >
                    <div class="main-list">
                        <p>
                            Do you have a Marriage Certificate
                            <span>{{checkProperty(petition['sponsorInfo'],'doYouHaveMarriageCert') | booleanFormat}}</span>
                        </p>
                    </div>
                </div> 
                <template v-if="checkProperty(petition['sponsorInfo'],'marriageCertDocs') && checkProperty(petition['sponsorInfo'],'marriageCertDocs','length')>0 && checkProperty(petition['sponsorInfo']  ,'doYouHaveMarriageCert')">
                    <vs-col class="padl0 padr0" v-if="checkProperty(petition['sponsorInfo'],'marriageCertDocs','length')>0" >
                        <documentsView @download_or_view="download_or_view" :type="'marriageCertDocs'"  :documentsList="petition['sponsorInfo']['marriageCertDocs']" :petitionDetails="petition" />
                    </vs-col>
                </template>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo']  ,'birthCertHaveNamePobDob') == true || checkProperty(petition['sponsorInfo']  ,'birthCertHaveNamePobDob') == false" >
                        <div class="main-list">
                            <p>
                                The birth certificate have your name, place of birth, date of birth, parents’ names mentioned, and the birth was registered around the time you were born
                                <span>{{checkProperty(petition['sponsorInfo']  ,'birthCertHaveNamePobDob') | booleanFormat}}</span>
                            </p>
                        </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo']  ,'have2AffidavitsOfBirthFamily') == true || checkProperty(petition['sponsorInfo']  ,'have2AffidavitsOfBirthFamily') == false" >
                    <div class="main-list">
                        <p>
                            Do you have Two (2) Affidavits of Birth from family members
                            <span>{{checkProperty(petition['sponsorInfo']  ,'have2AffidavitsOfBirthFamily') | booleanFormat}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo']  ,'nameDiffFromBirthCert') == true || checkProperty(petition['sponsorInfo']  ,'nameDiffFromBirthCert') == false" >
                        <div class="main-list">
                            <p>
                                Your name is different from that stated on your birth certificate, have you had it legally changes
                                <span>{{checkProperty(petition['sponsorInfo']  ,'nameDiffFromBirthCert') | booleanFormat}}</span>
                            </p>
                        </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident')" >
                    <div class="main-list">
                        <p>
                            I am filing this petition as 
                            <span v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'us_citizen'">US Citizen</span>
                            <span v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'permanent_resident'">Lawful Permanent Resident</span>
                
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" false &&  checkProperty(petition['sponsorInfo'],'usCitizen')" >
                    <div class="main-list">
                        <p>
                            If you are a U.S. Citizen? 
                            <span>{{checkProperty(petition['sponsorInfo'],'usCitizen') | booleanFormat}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'us_citizen' && checkProperty(petition['sponsorInfo'],'citizenshipAcquiredThrough')" >
                    <div class="main-list">
                        <p>
                            Citizenship was acquired through
                            <span v-if="checkProperty(petition['sponsorInfo'],'citizenshipAcquiredThrough')=='citizenshipBirth'"> Birth</span>
                            <span v-if="checkProperty(petition['sponsorInfo'],'citizenshipAcquiredThrough')=='citizenshipNaturalization'"> Naturalization</span>
                            <span v-if="checkProperty(petition['sponsorInfo'],'citizenshipAcquiredThrough')=='citizenshipParents'"> Parents</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'us_citizen' && checkProperty(petition['sponsorInfo'],'certOfCitizenNumber')" >
                    <div class="main-list">
                        <p>
                            Certificate of Citizenship Number
                            <span>{{checkProperty(petition['sponsorInfo'],'certOfCitizenNumber')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'us_citizen' && checkProperty(petition['sponsorInfo'],'placeOfIssuance')" >
                    <div class="main-list">
                        <p>
                            Place of Issuance
                            <span>{{checkProperty(petition['sponsorInfo'],'placeOfIssuance')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'us_citizen' && checkProperty(petition['sponsorInfo'],'dateOfIssuance')" >
                    <div class="main-list">
                        <p>
                            Date of Issuance
                            <span>{{checkProperty(petition['sponsorInfo'],'dateOfIssuance') | formatDate }}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="false && checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'permanent_resident' && canRenderField('lawfulPerResident',questionnaireDetails, false, 'sponsorInfo' )" >
                    <div class="main-list">
                        <p> 
                            If you are a Lawful Permanent Resident
                            <span>{{checkProperty(petition['sponsorInfo'],'lawfulPerResident') | booleanFormat}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md: w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'permanent_resident' &&checkProperty(petition['sponsorInfo']  ,'lprRequired')">
                    <div class="main-list">
                        <p>
                            LPR was acquired through
                            <span class="ownership_details" v-html="checkProperty(petition['sponsorInfo']  ,'lprRequired')"></span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'permanent_resident' && checkProperty(petition['sponsorInfo'],'dateReceivedLPR')" >
                    <div class="main-list">
                        <p>
                            Date received LPR
                            <span>{{checkProperty(petition['sponsorInfo'],'dateReceivedLPR') | formatDate}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'haveUSCitizenOrPermResident') == 'permanent_resident' && canRenderField('usCitizenOrLPR',questionnaireDetails, false, 'sponsorInfo' )" >
                    <div class="main-list">
                        <p>
                            Did you gain LPR through marriage to a U.S. citizen or a LPR?
                            <span>{{checkProperty(petition['sponsorInfo'],'usCitizenOrLPR') | booleanFormat}}</span>
                        </p>
                    </div>
                </div> 
                <!-- newly added fields starts -->
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" canRenderField('gainLawPermResidentThroughAdoption',questionnaireDetails, false, 'sponsorInfo' )" >
                    <div class="main-list">
                        <p>
                            Did you gain lawful permanent resident status or citizenship through adoption?
                            <span>{{checkProperty(petition['sponsorInfo'],'gainLawPermResidentThroughAdoption') | booleanFormat}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'lawFulPermanentResident','classOfAdmission')">
                        <div class="main-list">
                            <p>
                                Class of Admission
                                <span>{{checkProperty(petition['sponsorInfo'], 'lawFulPermanentResident','classOfAdmission') }}</span>
                            </p>
                        </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'lawFulPermanentResident','dateOfAdmission')">
                        <div class="main-list">
                            <p>
                                Date of Admission
                                <span>{{checkProperty(petition['sponsorInfo'], 'lawFulPermanentResident','dateOfAdmission') | formatDate }}</span>
                            </p>
                        </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'stateDetailsOfAdmission' ,'name')">
                        <div class="main-list">
                            <p>
                                State of Admission
                                <span>{{checkProperty(petition['sponsorInfo'],'stateDetailsOfAdmission' ,'name') }}</span>
                            </p>
                        </div>
                </div>
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'cityOfAdmission')">
                        <div class="main-list">
                            <p>
                                City or Town of Admission
                                <span>{{checkProperty(petition['sponsorInfo'],'cityOfAdmission') }}</span>
                            </p>
                        </div>
                </div>
               <!-- newly added fields end -->
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'countryOfCitizenshipDetails' ,'name')">
                        <div class="main-list">
                            <p>
                                Country of Citizenship
                                <span>{{checkProperty(petition['sponsorInfo'],'countryOfCitizenshipDetails' ,'name')}}</span>
                            </p>
                        </div>
                </div>  
                
                <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'dateFromUSCitizen')">
                        <div class="main-list">
                            <p>
                                Date from which you have resided in the USA
                                <span>{{checkProperty(petition['sponsorInfo'],'dateFromUSCitizen') | formatDate}}</span>
                            </p>
                        </div>
                </div>
               
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'filedOnAnyOtherPerOrPetitioner')" >
                    <div class="main-list">
                        <p>
                            Have you ever filed a petition for this beneficiary or any other person
                            <span>{{checkProperty(petition['sponsorInfo'],'filedOnAnyOtherPerOrPetitioner') | booleanFormat}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" checkProperty(petition['sponsorInfo'],'filedOnAnyOtherPerOrPetitioner') && checkProperty(petition['sponsorInfo'],'filedName')" >
                    <div class="main-list">
                        <p>
                            Name
                            <span>{{checkProperty(petition['sponsorInfo'],'filedName')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" checkProperty(petition['sponsorInfo'],'filedOnAnyOtherPerOrPetitioner') && checkProperty(petition['sponsorInfo'],'filedPlace')" >
                    <div class="main-list">
                        <p>
                            Place
                            <span>{{checkProperty(petition['sponsorInfo'],'filedPlace')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" checkProperty(petition['sponsorInfo'],'filedOnAnyOtherPerOrPetitioner') && checkProperty(petition['sponsorInfo'],'fileDateOfFiling')" >
                    <div class="main-list">
                        <p>
                            Date of Filing
                            <template>
                            <span>{{checkProperty(petition['sponsorInfo'],'fileDateOfFiling') | formatDate}}</span>
                            </template> 
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" checkProperty(petition['sponsorInfo'],'filedOnAnyOtherPerOrPetitioner') && checkProperty(petition['sponsorInfo'],'filedStatus')" >
                    <div class="main-list">
                        <p>
                            Filled status
                            <span>{{checkProperty(petition['sponsorInfo'],'filedStatus')}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" checkProperty(petition['sponsorInfo'],'filingThisPetitionerFor')" >
                    <div class="main-list">
                        <p>
                            I’M filing this petition for
                            <span>{{checkProperty(petition['sponsorInfo'],'filingThisPetitionerFor')}}</span>
                        </p>
                    </div>
                </div>
                <!-- newly added fields starts -->
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" checkProperty(petition['sponsorInfo'],'fillThisPetiChildOrParentRelation')" >
                    <div class="main-list">
                        <p>
                            Select the box that describes your relationship with beneficiary
                            <span>{{formatPetitionStatsVal(checkProperty(petition['sponsorInfo'],'fillThisPetiChildOrParentRelation'))}}</span>
                        </p>
                    </div>
                </div>
                <div class="vx-col  md:w-1/3 w-full p-0" v-if=" canRenderField('fillThisBroOrSisRelatedByAdoption',questionnaireDetails, false, 'sponsorInfo' )
                 && (checkProperty(petition['sponsorInfo'],'fillThisBroOrSisRelatedByAdoption') == false || checkProperty(petition['sponsorInfo'],'fillThisBroOrSisRelatedByAdoption') == true)" >
                    <div class="main-list">
                        <p>
                            Are you related to your brother/sister by adoption?
                            <span>{{checkProperty(petition['sponsorInfo'],'fillThisBroOrSisRelatedByAdoption') | booleanFormat}}</span>
                        </p>
                    </div>
                </div>

                <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'anyOtherElseFiledPetitionForBnf')" >
                    <div class="main-list">
                        <p>
                            Has anyone else ever filed a petition for the beneficiary?
                            <span>{{checkProperty(petition['sponsorInfo'],'anyOtherElseFiledPetitionForBnf')}}</span>
                        </p>
                    </div>
                </div>
                

                
                <!-- newly added fields end -->
            </div>
            <template v-if="canRenderField('benfEverInImmigrationProceedings',questionnaireDetails, false, 'sponsorInfo' ) || checkProperty(petition['sponsorInfo'],'typeOfProceedings') ||
             checkProperty(petition['sponsorInfo'],'dateOfProceedings') || checkProperty(petition['sponsorInfo'],'stateDetailsOfProceedings', 'name') || 
             checkProperty(petition['sponsorInfo'],'cityOfProceedings') ">
                <div class="vx-row m-0 main-list-panel">
                    <div class="vx-col  md:w-full w-full p-0" v-if=" canRenderField('benfEverInImmigrationProceedings',questionnaireDetails, false, 'sponsorInfo' )" >
                        <div class="main-list">
                            <p>
                                Was the beneficiary EVER in immigration proceedings?
                                <span>{{checkProperty(petition['sponsorInfo'],'benfEverInImmigrationProceedings') | booleanFormat }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'typeOfProceedings')" >
                        <div class="main-list">
                            <p>
                                Select the type of proceedings and provide the location and date of the proceedings
                                <span>{{formatProcedings(checkProperty(petition['sponsorInfo'],'typeOfProceedings'))}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'dateOfProceedings')" >
                        <div class="main-list">
                            <p>
                                Date of proceedings
                                <span>{{checkProperty(petition['sponsorInfo'],'dateOfProceedings') | formatDate}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'stateDetailsOfProceedings', 'name')" >
                        <div class="main-list">
                            <p>
                                State of proceedings
                                <span>{{checkProperty(petition['sponsorInfo'],'stateDetailsOfProceedings', 'name')}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="vx-col  md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'cityOfProceedings')" >
                        <div class="main-list">
                            <p>
                                City or Town of proceedings
                                <span>{{checkProperty(petition['sponsorInfo'],'cityOfProceedings')}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </template>
        <!---->
     
        <template v-if=" canRenderField('hasSubmitSepPetiForOtherRelation',questionnaireDetails, false, 'sponsorInfo' )">
            <div  class="vx-row m-0 main-list-panel"
            :class="{'bod-b0':checkProperty(petition['sponsorInfo'],'hasSubmitSepPetiForOtherRelation') && checkProperty(petition['sponsorInfo'],'submitSupPetiForOtherRelative')
                && checkProperty(petition['sponsorInfo'],'submitSupPetiForOtherRelative', 'length')>0 }">
                <div class="vx-col  md:w-full w-full p-0" v-if=" canRenderField('hasSubmitSepPetiForOtherRelation',questionnaireDetails, false, 'sponsorInfo' )" >
                    <div class="main-list">
                        <p>
                            Are you are also submitting separate petitions for other relatives
                            <span>{{checkProperty(petition['sponsorInfo'],'hasSubmitSepPetiForOtherRelation') | booleanFormat}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="petition_user_list" v-if="checkProperty(petition['sponsorInfo'],'hasSubmitSepPetiForOtherRelation') && checkProperty(petition['sponsorInfo'],'submitSupPetiForOtherRelative')
                && checkProperty(petition['sponsorInfo'],'submitSupPetiForOtherRelative', 'length')>0 ">
                <template  v-for="(item , ind)  in petition['sponsorInfo']['submitSupPetiForOtherRelative']">
                    <div  class="vx-row m-0 main-list-panel">
                        <!-- v-if="checkProperty( item,'relationShip')" v-if="checkProperty( item,'familyName')"
                        v-if="checkProperty( item,'givenName')"  v-if="checkProperty( item,'middleName')" -->
                        <div class="vx-col md:w-1/4 w-full p-0" >
                            <div class="main-list">
                                <p>
                                    Family Name
                                    <span v-if="checkProperty( item,'familyName')">{{checkProperty( item,'familyName')}}</span>
                                    <span v-else>--</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/4 w-full p-0" >
                            <div class="main-list">
                                <p>
                                    Given Name
                                    <span v-if="checkProperty( item,'givenName')">{{checkProperty( item,'givenName')}}</span>
                                    <span v-else>--</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/4 w-full p-0">
                            <div class="main-list">
                                <p>
                                    Middle Name
                                    <span v-if="checkProperty( item,'middleName')" >{{checkProperty( item,'middleName') }}</span>
                                    <span v-else>--</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/4 w-full p-0">
                            <div class="main-list">
                                <p>
                                    Relationship
                                    <span v-if="checkProperty( item,'relationShip')">{{checkProperty( item,'relationShip') }}</span>
                                    <span v-else>--</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- <div  class="divider full-divider mb-10"></div> -->
                </template>
            </div>
        </template>
        <template v-if="canRenderField('haveYouPrevFiledAnyPetitionForBnf',questionnaireDetails, false, 'sponsorInfo' )">
            <div  class="vx-row m-0 main-list-panel">
                    <div class="vx-col md:w-full w-full p-0" v-if="canRenderField('haveYouPrevFiledAnyPetitionForBnf',questionnaireDetails, false, 'sponsorInfo' )">
                        <div class="main-list">
                            <p>
                                Have you EVER previously filed a petition for this beneficiary or any other alien?
                                <span>{{checkProperty(petition['sponsorInfo'],'haveYouPrevFiledAnyPetitionForBnf') | booleanFormat}}</span>
                            </p>
                        </div>
                    </div>
                    <template v-if="checkProperty(petition['sponsorInfo'],'haveYouPrevFiledAnyPetitionForBnf')">
                        <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'familyName')">
                            <div class="main-list">
                                <p>
                                    Family Name
                                    <span>{{checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'familyName')}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'givenName')">
                            <div class="main-list">
                                <p>
                                    Given Name
                                    <span>{{checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'givenName')}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'middleName')">
                            <div class="main-list">
                                <p>
                                    Middle Name
                                    <span>{{checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'middleName')}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'stateDetailsOfFiling') && 
                        checkProperty(petition['sponsorInfo']['bnfPrevPetitionInfo'], 'stateDetailsOfFiling', 'name')">
                            <div class="main-list">
                                <p>
                                    State
                                    <span>{{checkProperty(petition['sponsorInfo']['bnfPrevPetitionInfo'], 'stateDetailsOfFiling', 'name')}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'cityOfFiling')">
                            <div class="main-list">
                                <p>
                                    City or Town
                                    <span>{{checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'cityOfFiling')}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'dateOfFiling')">
                            <div class="main-list">
                                <p>
                                    Date of Filed 
                                    <span>{{checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'dateOfFiling') | formatDate}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'status')">
                            <div class="main-list">
                                <p>
                                    Result
                                    <span>{{checkProperty(petition['sponsorInfo'],'bnfPrevPetitionInfo', 'status')}}</span>
                                </p>
                            </div>
                        </div>
                    </template>
                </div>
        </template>
        <template v-if="checkProperty(petition,'sponsorInfo' ,'hasOtherNames') && checkProperty(petition['sponsorInfo'] ,'otherNames' ,'length') >0">
                <div class="vx-row m-0 main-list-panel">
                    <h5 class="names_title">Used other names previously</h5>
                    <template v-for="(item , ind)  in petition['sponsorInfo']['otherNames']">
        
                        <div :key="ind" class="vx-col md:w-1/3 w-full p-0">
                            <div class="main-list">
                                <p>First Name<span v-if="item.firstName">{{item.firstName}}</span> 
                                    <span v-else>N/A</span>
                                </p>
                            </div>
                        </div>
                        <div :key="ind" class="vx-col md:w-1/3 w-full p-0">
                            <div class="main-list">
                                <p> Middle Name <span v-if="item.middleName"  >{{item.middleName}}</span>
                                    <span v-else>N/A</span>
                                </p>
                            </div>
                        </div>
        
                        <div :key="ind" class="vx-col md:w-1/3 w-full p-0">
                            <div class="main-list">
                                <p> Last Name <span v-if="item.lastName">{{item.lastName}}</span> 
                                    <span v-else>N/A</span>
                                </p>
                            </div>
                        </div>
        
                    </template>
        
                </div>
        
        </template>
            <div class="vx-row m-0 main-list-panel" v-if=" checkProperty(petition ,'sponsorInfo' ,'address' )  && 
                (
                    checkProperty(petition['sponsorInfo'] ,'address' ,'line1' )
                    || checkProperty(petition['sponsorInfo']['address'] ,'locationDetails' ,'name' )
                    || checkProperty(petition['sponsorInfo']['address'] ,'stateDetails' ,'name' )
                    || checkProperty(petition['sponsorInfo']['address'] ,'countryDetails' ,'name' )
                )">
                <div class="vx-col w-full p-0" >
                    <div class="main-list">
                        <p>
                            Current Address
                            <span v-html="$options.filters.addressformat(petition.sponsorInfo.address)"></span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="vx-row m-0 main-list-panel" v-if=" checkProperty(petition ,'sponsorInfo' ,'currentAddress')  && 
                (
                    checkProperty(petition['sponsorInfo'] ,'currentAddress' ,'line1' )
                    || checkProperty(petition['sponsorInfo']['currentAddress'] ,'locationDetails' ,'name' )
                    || checkProperty(petition['sponsorInfo']['currentAddress'] ,'stateDetails' ,'name' )
                    || checkProperty(petition['sponsorInfo']['currentAddress'] ,'countryDetails' ,'name' )
                    )">
                        <div class="vx-col w-full p-0" v-if=" checkProperty(petition ,'sponsorInfo' ,'currentAddress' )  && 
                        (
                            checkProperty(petition['sponsorInfo'] ,'currentAddress' ,'line1' )
                        || checkProperty(petition['sponsorInfo']['currentAddress'] ,'locationDetails' ,'name' )
                            || checkProperty(petition['sponsorInfo']['currentAddress'] ,'stateDetails' ,'name' )
                            || checkProperty(petition['sponsorInfo']['currentAddress'] ,'countryDetails' ,'name' )
        
                        )
                        ">
            <div class="main-list">
                <p>
        
                Mailing Address
                    <span v-html="$options.filters.addressformat(petition.sponsorInfo.currentAddress)"></span>
        
                </p>
            </div>
                        </div>
            </div>  
            <div class="vx-row m-0 main-list-panel" v-if=" checkProperty(petition ,'sponsorInfo' ,'addressOutsideUS' )  && 
                        (
                            checkProperty(petition['sponsorInfo'] ,'addressOutsideUS' ,'line1' )
        
                        || checkProperty(petition['sponsorInfo']['addressOutsideUS'] ,'locationDetails' ,'name' )
                            || checkProperty(petition['sponsorInfo']['addressOutsideUS'] ,'stateDetails' ,'name' )
                            || checkProperty(petition['sponsorInfo']['addressOutsideUS'] ,'countryDetails' ,'name' )
        
                        )
                        ">
        
            <div class="vx-col w-full p-0" v-if=" checkProperty(petition ,'sponsorInfo' ,'addressOutsideUS' )  && 
                        (
                            checkProperty(petition['sponsorInfo'] ,'addressOutsideUS' ,'line1' )
        
                        || checkProperty(petition['sponsorInfo']['addressOutsideUS'] ,'locationDetails' ,'name' )
                            || checkProperty(petition['sponsorInfo']['addressOutsideUS'] ,'stateDetails' ,'name' )
                            || checkProperty(petition['sponsorInfo']['addressOutsideUS'] ,'countryDetails' ,'name' )
        
                        )
                        ">
            <div class="main-list">
                <p>
        
                    Address Outside the U.S
                    <span v-html="$options.filters.addressformat(petition.sponsorInfo.addressOutsideUS)"></span>
        
                </p>
            </div>
        </div>
            </div>  
            <template v-if=" canRenderField('addressOfLastNYears',questionnaireDetails, false, 'sponsorInfo' ) &&
                checkProperty(petition ,'sponsorInfo' ,'addressOfLastNYears') &&  checkProperty(petition['sponsorInfo'] ,'addressOfLastNYears','length')>0 ">
                <div class="vx-row m-0 main-list-panel " v-if=" checkProperty(petition ,'sponsorInfo' ,'addressOfLastNYears' )  && 
                            (
                                checkProperty(petition['sponsorInfo']['addressOfLastNYears'][0] ,'line1' )

                            || checkProperty(petition['sponsorInfo']['addressOfLastNYears'][0] ,'locationDetails' ,'name' )
                                || checkProperty(petition['sponsorInfo']['addressOfLastNYears'][0] ,'stateDetails' ,'name' )
                                || checkProperty(petition['sponsorInfo']['addressOfLastNYears'][0] ,'countryDetails' ,'name' )

                            )
                            ">

                <div class="vx-col w-full p-0">
                <div class="main-list  p-0">
                    <p>
                        Residence starting with most current for the Past Five Years in the U.S and Abroad
                        <template v-if="checkProperty(petition ,'sponsorInfo', 'addressOfLastNYears')">
                            <!-- address_pad -->
                        <div :key="ind" class="vx-row m-0 main-list-panel " > 
                        <template v-for="(item , ind)  in petition['sponsorInfo']['addressOfLastNYears']">
                            <!-- map-pointer -->
                                <div class="vx-col  w-full  p-0 mt-3 ">
                                    <span v-html="$options.filters.addressformat(item)"></span>
                                </div>
                                <div class="main-list md:w-1/3 p-0 mt-1" v-if="canRenderField('startDate',questionnaireDetails, false, 'sponsorInfo.addressOfLastNYears' ) && item.startDate">
                                <p> Start Date<span>{{item.startDate | formatDate}}</span></p>
                                </div>
                                <div class="main-list md:w-1/3 p-0 mt-1" v-if="canRenderField('endDate',questionnaireDetails, false, 'sponsorInfo.addressOfLastNYears' ) && item.endDate">
                                    <p>End Date<span>{{item.endDate | formatDate}}</span></p>
                                </div>
                            </template>
                        </div>
                    </template>
                    </p>
                </div>
            </div>
                </div>
            </template>
            <template v-if="canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'sponsorInfo' ) &&
                checkProperty(petition ,'sponsorInfo' ,'addressOutsideUSMoreThanYear' ) && checkProperty(petition['sponsorInfo'] ,'addressOutsideUSMoreThanYear','length' )>0 ">
                <div class="vx-row m-0 main-list-panel" v-if=" checkProperty(petition ,'sponsorInfo' ,'addressOutsideUSMoreThanYear' )  && 
                    (
                        checkProperty(petition['sponsorInfo']['addressOutsideUSMoreThanYear'][0] ,'line1' )

                    || checkProperty(petition['sponsorInfo']['addressOutsideUSMoreThanYear'][0] ,'locationDetails' ,'name' )
                        || checkProperty(petition['sponsorInfo']['addressOutsideUSMoreThanYear'][0] ,'stateDetails' ,'name' )
                        || checkProperty(petition['sponsorInfo']['addressOutsideUSMoreThanYear'][0] ,'countryDetails' ,'name' )

                    )
                    ">

        <div class="vx-col w-full p-0">
        <div class="main-list  p-0">
            <p>
            Last Address outside Of the United States for more than one year
            <template v-if="checkProperty(petition,'sponsorInfo','addressOutsideUSMoreThanYear')">
                    <div :key="ind" class="vx-row m-0 main-list-panel " >
                    <template v-for="(item , ind)  in petition['sponsorInfo']['addressOutsideUSMoreThanYear']">
                            <div class="vx-col  w-full p-0 mt-3">
                                <span v-html="$options.filters.addressformat(item)"></span>
                            </div>
                            <div class="main-list md:w-1/3 p-0 mt-1" v-if="canRenderField('startDate',questionnaireDetails, false, 'sponsorInfo.addressOutsideUSMoreThanYear' ) && item.startDate">
                            <p> Start Date<span>{{item.startDate | formatDate}}</span></p>
                            </div>
                            <div class="main-list md:w-1/3 p-0 mt-1" v-if="canRenderField('endDate',questionnaireDetails, false, 'sponsorInfo.addressOutsideUSMoreThanYear' ) && item.endDate">
                                <p>End Date<span>{{item.endDate | formatDate}}</span></p>
                            </div>
                        </template>
                    </div>
                </template>
            </p>
        </div>
        </div>
        
            
                </div>
            </template>
            <div class="vx-row m-0 main-list-panel">
                <div class="vx-col  md:w-1/3 w-full p-0" v-if="canRenderField('previouslyMarried',questionnaireDetails, false, 'sponsorInfo' )" >
                    <div class="main-list">
                        <p>
                            Were you married previously? 
                            <template>
                                <span>{{checkProperty(petition['sponsorInfo'],'previouslyMarried') | booleanFormat}}</span>
                            </template>
                        </p>
                    </div>
                </div>
            </div>
            
            
        
                
                
            
        
                
                
        
        </div>
    </template>
    
    <script>
    import documentsView from "@/views/common/documentsView.vue";
    import _ from "lodash";
    export default {
        data: ()=>({
        visastatuses:[],
      }),
        props: {
            petition: {
                type: Object,
                default: null
            },
            tplSection:{
                type:String,
                default:''
            },
            questionnaireDetails:{
                type: Array,
                default: null
            }
            // visastatuses: {
            //     type: Array,
            //     default: null
            // }
        },
        computed: {     
            formatCountriesName(){
                return (data)=>{
                    let returnVal = ''
                    if(this.checkProperty(data, 'length')>0){
                    _.forEach(data, (itm)=>{
                        if(_.has(itm, 'name') && itm['name']){
                        if(returnVal != ''){
                            returnVal = returnVal + ', '+ itm['name']
                        }else{
                            returnVal = itm['name']
                        }
                        }
                    })
                    }
                    return returnVal;
                }
            },  
            checkChildH4(){
                let returnVal = false;
                let self = this;
                if(self.checkProperty(self.petition['dependentsInfo'] ,'childrens') && self.checkProperty(self.petition['dependentsInfo'] ,'childrens', 'length')>0
                && self.canRenderField('h4Required',self.questionnaireDetails, false, 'dependentsInfo.childrens' ) ){
                    let findObj = _.find(self.petition['dependentsInfo']['childrens'], {'h4Required':true});
                    if(findObj){
                        returnVal = true;
                    }
                }
                return returnVal
            },    
            formatFullname(item){
                    let returnVal = ''
                    if(this.checkProperty(item,'name')){
                        return returnVal = this.checkProperty(item,'name')
                    }
                    else{
                        if(this.checkProperty(item,'firstName')){
                            returnVal = this.checkProperty(item,'firstName')
                        }
                        if(this.checkProperty(item,'middleName')){
                             returnVal = returnVal +' '+ this.checkProperty(item,'middleName')
                        }
                        if(this.checkProperty(item,'lastName')){
                            returnVal =  returnVal +' '+this.checkProperty(item,'lastName')
                        }
                        return returnVal
                    }
                },
            checkNoofDays(){
                let returnVal = true
                //petition.sponsorInfo.priorPeriodOfStayInUS
                if(this.checkProperty(this.petition['sponsorInfo'] ,'priorPeriodOfStayInUS') && this.checkProperty(this.petition['sponsorInfo'] ,'priorPeriodOfStayInUS', 'length')>0 ){
                   let noOfDaysList =  _.filter(this.petition.sponsorInfo.priorPeriodOfStayInUS, (item)=>{
                        if(item && item['noOfDays']){
                           return item
                        }
                    })
                    if(noOfDaysList && this.checkProperty(noOfDaysList,'length')>0){
                        returnVal = true
                    }else{
                        returnVal = false
                    }
                }
                return returnVal
            },
            showRouteName(){
                if(this.$route.name == 'questionnaire'){
                    return false
                }
                else{
                    return true
                }
            }
        },
        methods:{
            formatProcedings(val){
                let returnVal = '';
                if(val){
                    if(val == 1){
                        returnVal = "Removal"
                    }
                    if(val == 2){
                        returnVal = "Exclusion/Deportation"
                    }
                    if(val == 3){
                        returnVal = "Rescission"
                    }
                    if(val == 4){
                        returnVal = "Other Judicial Proceedings"
                    }
                }
                return returnVal;
            },
            formatPetitionStatsVal(val){
                let returnVal = '';
                if(val){
                    if(val == 1){
                        returnVal = "Child was born to parents who were married to each other at the time of the child's birth"
                    }
                    if(val == 2){
                        returnVal = "Stepchild/Stepparent"
                    }
                    if(val == 3){
                        returnVal = "Child was born to parents who were not married to each other at the time of the child's birth"
                    }
                    if(val == 4){
                        returnVal = "Child was adopted (not an Orphan or Hague Convention adoptee)"
                    }
                }
                return returnVal;
            },
            formatStatus(val){
                let returnVal = '';
                if(val){
                    if(val == 'approved'){
                        returnVal = 'Approved'
                    }
                    if(val == 'denied'){
                        returnVal = 'Denied'
                    }
                    if(val == 'not_used'){
                        returnVal = 'Not Used'
                    }
                    
                }
                return returnVal
            },
            convertHeight(val){
                
                if(val){
                    let returnVal = null;
                    let feet = ''
                    let inches = ''
                    if( _.has(val,'feet')){
                        feet = val['feet']
                    }
                    if(_.has(val,'inches')){
                        inches = val['inches']
                    }
                    if(feet){
                        returnVal = feet+"'"+inches+"''"
                    }
                    return returnVal
                }
            },
            download_or_view(value) {
            this.$emit('download_or_view' ,value);
         },
  
            getVisastatues(){
          this.$store.dispatch("getmasterdata", "visa_status").then((response) => {
            this.visastatuses = response;
          });
        },
        },
        mounted(){
            this.getVisastatues()
        },
        components:{
            documentsView,
        },
    };
    </script>
    